import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as subaward from '../subaward'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: subaward.RESOURCE.payload.dimension.partialId,
      partialId: subaward.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    default: false,
    description:
      'Indicates that this subaward is really the extension of an existing subaward AND that the extension is being done as an ammendment to the original contract',
    isOptional: false,
    name: 'Is Ammendment?',
    partialId: PartialId.Standard.create('is_ammend'),
    type: core.common.value.types.Intrinsic.Boolean,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
